import { create } from "zustand";
import { notifications as seed } from "@/mocks/seed";
import type { NotificationItem } from "@/types";

/** Mock store for notifications when unauthenticated / API down (Phase 5.4). */
interface NotificationsState {
  items: NotificationItem[];
  markRead: (id: string) => void;
  markAllRead: () => void;
}

export const useNotificationsStore = create<NotificationsState>((set) => ({
  items: seed,
  markRead: (id) =>
    set((s) => ({ items: s.items.map((n) => (n.id === id ? { ...n, read: true } : n)) })),
  markAllRead: () => set((s) => ({ items: s.items.map((n) => ({ ...n, read: true })) })),
}));
